
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SKURepricingBOMDialog extends Common.GridEditorDialog<SKURepricingBOMRow> {
        protected getFormKey() { return SKURepricingBOMForm.formKey; }
        //protected getIdProperty() { return SKURepricingBOMRow.idProperty; }
        protected getLocalTextPrefix() { return SKURepricingBOMRow.localTextPrefix; }
        //protected getNameProperty() { return SKURepricingBOMRow.nameProperty; }
        //protected getService() { return SKURepricingBOMService.baseUrl; }
        protected getDeletePermission() { return SKURepricingBOMRow.deletePermission; }
        protected getInsertPermission() { return SKURepricingBOMRow.insertPermission; }
        protected getUpdatePermission() { return SKURepricingBOMRow.updatePermission; }

        protected form = new SKURepricingBOMForm(this.idPrefix);

    }
}